import { isArray } from "lodash";
import { CONST_VALUES } from "../constants/constants";
import { STORAGE_OPTIONS_VALUE } from "./commonFuntions";
import { unitGroupList } from "../constants/unitConstants";

export function getDeepLink() {
  const url = window?.location?.href;
  let deepLinkPart = "";
  let parts = null;
  if (url != null && url != "") {
    parts = url?.split("#");
    deepLinkPart = parts[1];
  }

  return deepLinkPart;
}

export function getRelayState(param) {
  if (
    param.split("/")[1] === "asset-details" ||
    param.split("/")[1] === "inventory" ||
    param.split("/")[1] === "permissions" ||
    param.split("/")[1] === "asset-report" ||
    param.split("/")[1] === "alerts" ||
    param.split("/")[1] === "asset-info" ||
    param.split("/")[1] === "site-info" ||
    param.split("/")[1] === "credentials" ||
    param.split("/")[1] === "customer-demo" ||
    param.split("/")[1] === "partner-demo"
  ) {
    return (
      "?RelayState=" +
      "deepLink=" +
      encodeURIComponent(decodeURIComponent(param))
    );
  } else {
    return "";
  }
}

function validateIPaddress(ipaddress) {
  if (
    /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ipaddress
    )
  )
    return true;
  return false;
}

export function escapeInnerOuterHTML(dirtyHtml) {
  // Create a temporary element
  const temp = document.createElement("div");
  temp.innerHTML = dirtyHtml;

  // Remove any script tags
  const scripts = temp.getElementsByTagName("script");
  for (let i = scripts.length - 1; i >= 0; i--) {
    scripts[i].parentNode.removeChild(scripts[i]);
  }

  // Remove any event attributes
  const elements = temp.querySelectorAll("*");
  elements.forEach(element => {
    const attributes = element.attributes;
    for (let i = attributes.length - 1; i >= 0; i--) {
      const attributeName = attributes[i].name;
      if (attributeName.startsWith("on")) {
        element.removeAttribute(attributeName);
      }
    }
  });

  // Return the sanitized HTML
  return temp.innerHTML;
}

export function validateUrlForSec(url_details) {
  var parser = document?.createElement("a");
  parser.href = url_details;

  if (url_details?.includes("https")) {
    let hostname = parser?.hostname;
    let onlydomain = hostname?.split(".");
    onlydomain =
      onlydomain[onlydomain?.length - 2] +
      "." +
      onlydomain[onlydomain?.length - 1];
    if (
      CONST_VALUES?.valid_hostnames?.includes(hostname) ||
      CONST_VALUES?.valid_hostnames?.includes(onlydomain) ||
      validateIPaddress(hostname)
    ) {
      if (
        CONST_VALUES?.invalid_chars?.find(a => url_details?.includes(a)) ===
        undefined
      ) {
        return url_details;
      } else {
        return "/";
      }
    } else {
      return "/";
    }
  } else if (url_details?.startsWith("/")) {
    return url_details;
  } else {
    return "";
  }
}

// Temp fix to handle download csv asked by Ganesh

export function validateUrlForExcel(url_details) {
  var parser = document?.createElement("a");
  parser.href = url_details;

  let hostname = parser?.hostname;
  let onlydomain = hostname?.split(".");
  onlydomain =
    onlydomain[onlydomain?.length - 2] +
    "." +
    onlydomain[onlydomain?.length - 1];
  if (
    CONST_VALUES.valid_hostnames.includes(hostname) ||
    CONST_VALUES.valid_hostnames.includes(onlydomain) ||
    validateIPaddress(hostname)
  ) {
    if (
      CONST_VALUES.invalid_chars?.find(a => url_details?.includes(a)) ===
      undefined
    ) {
      return url_details;
    } else {
      return "/";
    }
  } else {
    return "/";
  }
}

export function checkValidUrl() {
  try {
    // intentionally kept empty
  } catch (e) {
    window.location.href = "/";
  }
}

export function getLocalStorageValue(data) {
  switch (data) {
    case "zero":
      return 0;
    case "one":
      return 1;
    default:
      break;
  }
}

export function validateLocalStorageValue(data) {
  let values = [
    "0",
    "1",
    "overview",
    "block",
    "object",
    "file",
    "sustainability",
    "security"
    // "null"
  ];
  if (values.indexOf(String(data)) > -1) {
    return data;
  } else {
    return -1;
  }
}

export const transformDataCustomSelect = data => {
  return data.map(row => ({
    id: row?.id,
    value: row?.label,
    label: row?.label
  }));
};

export const transformReactSelectData = (data, typeId) => {
  return data.map(row => {
    let type;
    if (typeId === 1) {
      type = "block";
    } else if (typeId === 2) {
      type = "object";
    } else {
      type = "file";
    }
    return {
      value: row?.salesforce_site_id,
      label: row?.salesforce_site_id,
      id: row?.salesforce_site_id,
      siteWithAlias: row?.site_name
        ? `${row?.salesforce_site_id}` + ` (${row?.site_name})`
        : row?.salesforce_site_id,
      type: type
    };
  });
};

export const transformSitesdropdownData = data => {
  return data.map(row => {
    const typeMap = {
      1: "block",
      2: "object"
    };

    const type = typeMap[row?.product_category_id] || "file";
    let text =
      row?.salesforce_site_id == "-"
        ? `${row?.site_id} (HRO Site ID)`
        : row?.salesforce_site_id;

    let siteId = row?.site_id?.split(" ")[0]?.split("/")?.[0];
    let siteCopy =
      row?.salesforce_site_id == "-" ? siteId : row?.salesforce_site_id;
    return {
      // value: row?.salesforce_site_id,
      // label: row?.site_name
      //   ? `${row?.salesforce_site_id}` + ` (${row?.site_name})`
      //   : row?.salesforce_site_id,
      // id: row?.salesforce_site_id,
      // siteWithAlias: row?.site_name
      //   ? `${row?.salesforce_site_id}` + ` (${row?.site_name})`
      //   : row?.salesforce_site_id,
      value: text,
      label: row?.site_name ? `${text}` + ` (${row?.site_name})` : text,
      id: text,
      siteWithAlias: row?.site_name ? `${text}` + ` (${row?.site_name})` : text,
      type: type,
      hitrackSiteId: row?.site_id,
      resolvedSiteId: siteCopy
    };
  });
};

export const debounceFun = (func, delay) => {
  let debounceTimer;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const displayValue = value => {
  if (value === null) {
    return "null";
  } else if (value === "") {
    return '""';
  } else {
    return value?.toString();
  }
};

const valueIsObject = obj => {
  return !Array.isArray(obj) && typeof obj === "object" && obj !== null;
};

export const filterObjectByKey = (query, obj) => {
  const q = query?.toLowerCase?.().trim();

  if (valueIsObject(obj)) {
    let buffer = {};
    for (let key in obj) {
      if (key?.toLowerCase().includes(q) || valueIsObject(obj[key])) {
        if (valueIsObject(obj[key])) {
          let filteredValueObject = filterObjectByKey(q, obj[key]);
          if (Object.keys(filteredValueObject).length !== 0) {
            buffer[key] = filteredValueObject;
          }
        }

        if (key.toLowerCase().includes(q)) {
          buffer[key] = obj[key];
        }
      }
    }
    return buffer;
  } else if (Array.isArray(obj)) {
    return obj.map(n => filterObjectByKey(q, n));
  }
};

export const itemLabel = (element, i, rootElement, parent) => {
  try {
    if (Array.isArray(element)) {
      return `${parent || "array"} [${element?.length}]`;
    } else if (
      typeof element === "object" &&
      !Array.isArray(element) &&
      !rootElement
    ) {
      return `${parent || "object"} {${element &&
        Object.keys(element)?.length}}`;
    } else {
      return `${i} {${element && Object.keys(element)?.length}}`;
    }
  } catch (e) {
    console.error(e);
  }
};
export const convertToLowerAndTrim = value => {
  return value?.toLowerCase()?.trim();
};

export const getProductCategoryId = storageOption => {
  return STORAGE_OPTIONS_VALUE[storageOption?.toLowerCase()] || "";
};

export const removeDuplicates = (array, key) => {
  return array.filter(
    (item, index, self) => index === self.findIndex(t => t[key] === item[key])
  );
};

export const getSiteDropOptions = (user, selectedCustomer) => {
  let options = [
    {
      id: 0,
      type: CONST_VALUES.all_sites,
      label: CONST_VALUES.all_sites,
      hitrackSiteId: CONST_VALUES.all_sites,
      value: CONST_VALUES.all_sites,
      resolvedSiteId: CONST_VALUES.all_sites
    }
  ];
  if (
    user?.role !== CONST_VALUES.INTUSER &&
    user?.role !== CONST_VALUES.PARTNER
  ) {
    options.push({
      id: 0,
      type: CONST_VALUES.favourites,
      label: CONST_VALUES.favourites,
      value: CONST_VALUES.favourites,
      hitrackSiteId: CONST_VALUES.favourites,
      resolvedSiteId: CONST_VALUES.favourites
    });
  }
  if (user && isArray(user?.listOfSites)) {
    let filteredListOfSites = user?.listOfSites;

    // Filter sites before mapping if user role is "INTUSER"
    if (
      user?.role === "INTUSER" &&
      selectedCustomer !== "All Customers" &&
      selectedCustomer !== undefined
    ) {
      filteredListOfSites = filteredListOfSites.map(siteCategory => ({
        ...siteCategory,
        sites: siteCategory?.sites?.filter(
          site => site?.customer_name === selectedCustomer
        )
      }));
    }
    const allSitesWithCategory = filteredListOfSites?.flatMap(item =>
      item?.sites?.map(site => ({
        ...site,
        product_category: item.product_category,
        product_category_id: item.product_category_id
      }))
    );
    let sites = transformSitesdropdownData(allSitesWithCategory);
    const uniqueOptions = Array.from(
      new Map(
        options
          .concat(sites)
          ?.map(option => [`${option.value}-${option.label}`, option])
      ).values()
    );
    options = uniqueOptions;
  }
  return sortSites(options);
};

function sortSites(data) {
  const topLabels = ["All Sites", "Favorites"];

  return data?.sort((a, b) => {
    const aIsTop = topLabels?.includes(a.label);
    const bIsTop = topLabels?.includes(b.label);

    if (aIsTop && bIsTop) {
      return topLabels.indexOf(a.label) - topLabels.indexOf(b.label);
    } else if (aIsTop) {
      return -1;
    } else if (bIsTop) {
      return 1;
    } else {
      return a?.label?.localeCompare(b.label);
    }
  });
}

export const sortingInAscending = customerOptions => {
  return customerOptions?.sort((a, b) => {
    // Define invalid labels to keep at the bottom
    const invalidLabels = ["-", "Not Available"];

    // Ensure "All Customers" is always at the top
    if (a?.label === "All Customers") return -1;
    if (b?.label === "All Customers") return 1;

    // If both labels are invalid, keep them in the same relative order
    if (
      invalidLabels?.includes(a?.label) &&
      invalidLabels?.includes(b?.label)
    ) {
      return 0;
    }

    // If a label is invalid and b is not, move a to the bottom
    if (invalidLabels?.includes(a?.label)) {
      return 1;
    }

    // If b label is invalid, move b to the bottom
    if (invalidLabels?.includes(b?.label)) {
      return -1;
    }

    // If both labels are valid, compare them alphabetically
    return a?.label?.localeCompare(b?.label);
  });
};

export const getCustomerDropOptions = user => {
  const customerNames = [
    ...new Set(user?.site_info?.map(item => item?.customer_name))
  ];
  const customerOptions = [
    { value: "All Customers", label: "All Customers" },
    ...customerNames.map(customer_name => ({
      value: customer_name,
      label: customer_name
    }))
  ];
  const sortedItems = sortingInAscending(customerOptions);
  return sortedItems;
};

export const checkAllAssetsExpired = (user, productCategoryId) => {
  let filteredSites = user?.listOfSites?.filter(
    el => el?.product_category_id === productCategoryId
  );
  if (
    filteredSites?.[0]?.sites?.filter(elem => elem?.is_expired_site)?.length ==
    filteredSites?.[0]?.sites?.length
  ) {
    return true;
  }
  return false;
}; // need to use it in Analytics and SideNavbar

export const checkAndSetStorageType = (
  user,
  selectedCustomer,
  selectedSite,
  excludeSecondaryStorageOptions
) => {
  const checkSiteAvailability = (productCategoryId, siteIds) => {
    if (
      ["all sites", "favorites"]?.includes(
        selectedSite?.label?.toLowerCase() || selectedSite?.toLowerCase()
      )
    ) {
      return (
        user?.listOfSites
          ?.filter(el => el?.product_category_id === productCategoryId)
          ?.map(el => el?.sites)
          ?.flat(1)
          ?.some(elem =>
            siteIds?.some(
              site =>
                site?.id === elem?.salesforce_site_id ||
                site?.resolvedSiteId === elem?.salesforce_site_id ||
                site.resolvedSiteId === elem?.site_id ||
                site?.value === elem?.salesforce_site_id
            )
          ) || false
      );
    }
    return (
      user?.listOfSites
        ?.filter(el => el?.product_category_id === productCategoryId)
        ?.map(el => el?.sites)
        ?.flat(1)
        ?.some(elem =>
          siteIds?.some(
            site =>
              (selectedSite.resolvedSiteId || selectedSite) ===
                elem?.salesforce_site_id ||
              (selectedSite.resolvedSiteId || selectedSite) === elem?.site_id
          )
        ) || false
    );
  };

  let options = getSiteDropOptions(user, selectedCustomer);
  const isBlockEnable = checkSiteAvailability("1", options);
  const isObjectEnable = checkSiteAvailability("2", options);
  const isFileEnable = checkSiteAvailability("3", options);
  const array = [
    { enabled: isBlockEnable, category: "block" },
    { enabled: isObjectEnable, category: "object" },
    { enabled: isFileEnable, category: "file" }
  ];
  const found = array.find(item => item.enabled === true);
  const _storageOption = found?.category?.toLowerCase() || "block";
  const existingStorageOption = localStorage.getItem("storageOption");
  if (!excludeSecondaryStorageOptions && user?.role !== CONST_VALUES.PARTNER) {
    if (
      (existingStorageOption == "block" && isBlockEnable) ||
      (existingStorageOption == "object" && isObjectEnable) ||
      (existingStorageOption == "file" && isFileEnable) ||
      existingStorageOption == "overview" ||
      existingStorageOption == "security" ||
      existingStorageOption == "sustainability"
    ) {
      return existingStorageOption;
    } else {
      // if (
      //   validateLocalStorageValue(localStorage.getItem("storageOption")) !== -1
      // ) {
      localStorage.setItem("storageOption", _storageOption);
      // }
      return _storageOption;
    }
  } else {
    if (
      (existingStorageOption == "block" && isBlockEnable) ||
      (existingStorageOption == "object" && isObjectEnable) ||
      (existingStorageOption == "file" && isFileEnable)
    ) {
      return existingStorageOption;
    } else {
      // if (
      //   validateLocalStorageValue(localStorage.getItem("storageOption")) !== -1
      // ) {
      localStorage.setItem("storageOption", _storageOption);
      // }
      return _storageOption;
    }
  }
};

export const checkSiteAvailabilityWithoutExpiryCheck = (
  user,
  productCategoryId,
  selectedSite
) => {
  return user?.listOfSites
    ?.filter(el => el?.product_category_id === productCategoryId)
    ?.map(el => el?.sites)
    ?.flat(1)
    ?.some(elem => elem?.salesforce_site_id === selectedSite);
};

export const checkSiteAvailabilityForIntuser = (
  user,
  productCategoryId,
  selectedSite,
  selectedCustomer
) => {
  return user?.listOfSites
    ?.filter(el => el?.product_category_id === productCategoryId)
    ?.map(el => el?.sites)
    ?.flat(1)
    ?.some(
      elem =>
        (elem?.customer_name === selectedCustomer &&
          elem.salesforce_site_id === selectedSite?.label) ||
        elem?.salesforce_site_id == selectedSite?.resolvedSiteId ||
        elem?.site_id == selectedSite?.resolvedSiteId
    );
};

export const filterUniqueSitesForIntUser = (
  sites,
  selectedCustomer,
  selectedSite,
  isSustainability = false
) => {
  const isAllCustomers = selectedCustomer?.toLowerCase?.() === "all customer";
  const isAllSites = isSustainability
    ? true
    : selectedSite?.hitrackSiteId?.toLowerCase?.() === "all sites";
  // Step 1: Apply filtering logic
  const filtered = sites?.filter(site => {
    const customerMatches =
      isAllCustomers || site.customer_name === selectedCustomer;
    const siteMatches =
      isAllSites || site?.site_id === selectedSite?.hitrackSiteId;
    return customerMatches && siteMatches;
  });

  // Step 2: Remove duplicates using salesforce_site_id as unique key
  const uniqueBySiteId = Array.from(
    new Map(filtered?.map(site => [site?.salesforce_site_id, site]))?.values()
  );

  return uniqueBySiteId?.map(site => String(site?.site_id));
};

export const filterUniqueSitesForCustomer = (
  sites,
  selectedSite,
  isSustainability = false
) => {
  // const isAllSites =
  //   selectedSite?.hitrackSiteId?.toLowerCase?.() === "all sites";

  const isAllSites = isSustainability
    ? true
    : selectedSite?.hitrackSiteId?.toLowerCase?.() === "all sites";

  // Step 1: Apply filtering logic
  const filtered = sites?.filter(site => {
    const siteMatches =
      isAllSites || site?.site_id === selectedSite?.hitrackSiteId;
    return siteMatches;
  });

  // Step 2: Remove duplicates using salesforce_site_id as unique key
  const uniqueBySiteId = Array.from(
    new Map(filtered?.map(site => [site?.salesforce_site_id, site]))?.values()
  );

  return uniqueBySiteId?.map(site => String(site?.site_id));
};

export const getSustainabilityParams = (user, site, selectedCustomer) => {
  if (user?.role == CONST_VALUES.CUSTOMER) {
    // if (site?.id?.toLowerCase() == "favorites") {
    //   return { favourites: true };
    // } else {  // On First load passing All sites for Fav and All sites
    let selectedSite =
      selectedSite?.hitrackSiteId?.toLowerCase?.() === "all sites";
    let siteIds = filterUniqueSitesForCustomer(user?.site_info, site, true);
    let params;
    params =
      "[" +
      String(siteIds)
        ?.split(",")
        ?.map(s => `'${s}'`)
        ?.join(",") +
      "]";
    return { site_id: params };
    // }
  } else {
    if (user?.role == CONST_VALUES.INTUSER) {
      let siteIds = filterUniqueSitesForIntUser(
        user?.site_info,
        selectedCustomer,
        site,
        true
      );
      const sustainabilityParams = {
        site_id: `[${siteIds?.map(id => `'${id}'`).join(", ")}]`
      };
      return sustainabilityParams;
    }
  }
};
export const resetSiteDropdownToAllSites = () => {
  let site = {
    id: CONST_VALUES.all_sites,
    type: CONST_VALUES.all_sites,
    label: CONST_VALUES.all_sites,
    hitrackSiteId: CONST_VALUES.all_sites,
    value: CONST_VALUES.all_sites,
    resolvedSiteId: CONST_VALUES.all_sites,
    selected: true,
    isHidden: false
  };
  return site;
};

export const isIOSApp = () => {
  // check for only ios app
  return (
    window.webkit &&
    window.webkit.messageHandlers &&
    !/CriOS/.test(navigator.userAgent)
  );
};

export const isNativeIOSApp = () => {
  return (
    typeof window !== "undefined" && window.__IS_REACT_NATIVE_APP__ === true
  );
};

export const isAndroidApp = () => {
  // check for only android app
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    document.referrer.startsWith("android-app://")
  );
};

export const mergeUniqueByKeys = (arr1, arr2, keys) => {
  const safeArr1 = (Array.isArray(arr1) && arr1) || [];
  const safeArr2 = (Array.isArray(arr2) && arr2) || [];

  const map = new Map();

  [...safeArr1, ...safeArr2].forEach(item => {
    const compositeKey = keys.map(key => item?.[key]).join("|");
    map.set(compositeKey, item);
  });

  return Array.from(map.values());
};

export const arraysAreEqual = (arr1, arr2) => {
  if (arr1?.length !== arr2?.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((value, index) => value === sorted2[index]);
};

export const getFormattedDateTime = () => {
  const now = new Date();

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const sec = String(now.getSeconds()).padStart(2, "0");

  return `${yyyy}${mm}${dd}_${hh}_${min}_${sec}`;
};

export const getCapacityMessages = status => {
  switch (status?.toUpperCase()) {
    case "CRITICAL":
      return {
        tooltipMessage: "System is running out of storage space.",
        advisoryMessage: "Contact your Hitachi Vantara sales rep immediately."
      };
    case "WARNING":
      return {
        tooltipMessage: "Capacity usage is nearing a critical state.",
        advisoryMessage: "Contact your Hitachi Vantara sales rep."
      };
    default:
      return {
        tooltipMessage: null,
        advisoryMessage: null
      };
  }
};

// formal decimal point for value
export const formatDecimalNumber = (value, position = 1) => {
  const num = Number(value);

  if (isNaN(num)) return value;

  return Number.isInteger(num) ? num.toString() : num.toFixed(position);
};

/**
 * This method will convert value from currentUnit to newUnit.
 * @param currentUnit
 * @param newUnit
 * @param currentValue
 */
export const getUnitConversionValue = (currentUnit, newUnit, currentValue) => {
  if (
    currentValue === null ||
    currentValue === undefined ||
    currentValue === ""
  ) {
    return null;
  }

  let convertedValue = currentValue;

  if (currentUnit === newUnit) {
    return Number(convertedValue); //convert to number if value is in string format
  }

  if (!unitGroupList) {
    return null;
  }

  for (let group of unitGroupList?.unitGroupList) {
    let currentFactor;
    let newFactor;

    for (const unit of group?.unitGroup) {
      if (unit?.id === currentUnit) {
        currentFactor = unit?.factor;
      }

      if (unit?.id === newUnit) {
        newFactor = unit?.factor;
      }

      if (currentFactor != null && newFactor != null) {
        break;
      }
    }

    if (currentFactor == null || newFactor == null) {
      continue;
    }

    convertedValue = (convertedValue / currentFactor) * newFactor;
    break;
  }

  return convertedValue;
};

/**
 * This method will round value from baseUnit into max possible unit.
 * @param value
 * @param baseUnit
 * @param decimalPrecision - number of decimals to be shown in converted value, default is 1
 */
export const convertUnit = (value, baseUnit, precisionDecimal = 1) => {
  const unitThreshold = 1024;

  if (!Number.isFinite(value)) {
    return {
      data: "-",
      unit: baseUnit
    };
  }

  if (
    Number(value?.toFixed(precisionDecimal)) < unitThreshold ||
    !unitGroupList
  ) {
    return {
      data: value.toFixed(precisionDecimal),
      unit: baseUnit
    };
  }

  const unitConversionFactors = unitGroupList?.unitGroupList.find(group =>
    group.unitGroup.some(el => el?.id === baseUnit)
  )?.unitGroup;

  if (unitConversionFactors == null) {
    return {
      data: value.toFixed(precisionDecimal),
      unit: baseUnit
    };
  }

  let conversionRequired = false;

  for (let i = 0; i < unitConversionFactors.length; i++) {
    if (
      unitConversionFactors[i].id === baseUnit &&
      i !== unitConversionFactors.length - 1
    ) {
      conversionRequired = true;
      continue;
    }

    if (conversionRequired) {
      let convertedValue =
        (value * unitConversionFactors[i].factor) /
        unitConversionFactors[i - 1].factor;

      if (convertedValue < unitThreshold) {
        return {
          data: convertedValue.toFixed(precisionDecimal),
          unit: unitConversionFactors[i].id
        };
      } else {
        return convertUnit(
          convertedValue,
          unitConversionFactors[i].id,
          precisionDecimal
        );
      }
    }
  }

  return {
    data: value.toFixed(precisionDecimal),
    unit: baseUnit
  };
};

//format date to locale
//2026-05-01 -> 1May2026
export function formatDateToLocale(dateStr) {
  return new Date(dateStr)
    .toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric"
    })
    .replace(/\s/g, "");
}
